import { useState, useRef, useEffect } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Checkbox } from '@/components/ui/checkbox';

function MultiSelectFilter({ options, value, onChange, placeholder, testId }) {
  const [open, setOpen] = useState(false);
  const selectedValues = value ? value.split(',').filter(Boolean) : [];

  const handleToggle = (option) => {
    let newValues;
    if (selectedValues.includes(option)) {
      newValues = selectedValues.filter(v => v !== option);
    } else {
      newValues = [...selectedValues, option];
    }
    onChange(newValues.join(','));
  };

  const handleSelectAll = () => {
    onChange('all');
  };

  const displayText = () => {
    if (!value || value === 'all') {
      return '-- Tutti --';
    }
    const count = selectedValues.length;
    if (count === 0) return '-- Tutti --';
    if (count === 1) return selectedValues[0];
    return `${count} selezionati`;
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-[200px] justify-between bg-black/20 border-[rgb(39,39,42)] hover:bg-black/30 font-mono text-sm"
          data-testid={testId}
        >
          <span className="truncate">{displayText()}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0 bg-[rgb(24,24,27)] border-[rgb(39,39,42)]">
        <div className="max-h-[300px] overflow-y-auto">
          <div
            className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-white/5 border-b border-[rgb(39,39,42)]"
            onClick={handleSelectAll}
          >
            <Checkbox
              checked={!value || value === 'all'}
              className="border-[rgb(59,130,246)]"
            />
            <span className="font-mono text-sm font-bold text-[rgb(250,250,250)]">-- Tutti --</span>
          </div>
          {options.map((option) => (
            <div
              key={option}
              className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-white/5"
              onClick={() => handleToggle(option)}
            >
              <Checkbox
                checked={selectedValues.includes(option)}
                className="border-[rgb(59,130,246)]"
              />
              <span className="font-mono text-sm text-[rgb(250,250,250)]">{option}</span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default MultiSelectFilter;
